<template>
  <div id="jinrishuju">
    <ul class="jinrilist">
      <li v-for="(n, index) in list" :key="index">
        <!--顶部-->
        <div class="lan">
          <p class="flex-box">
            <span>直播时间</span>
            <span>{{ n.time }}</span>
          </p>
          <p class="flex-box">
            <span>直播时长</span>
            <span>{{ n.duration }}</span>
          </p>
          <p class="flex-box">
            <span>直播标题</span>
            <span class="apostrophe">{{ n.title }}</span>
          </p>
        </div>

        <!--数量统计-->
        <div class="number flex-box">
          <div>
            观看人数
            <span>{{ n.view_number }}</span>
          </div>
          <div>
            送礼人数
            <span>{{ n.give_a_gift_number }}</span>
          </div>
          <div>
            新增粉丝
            <span>{{ n.add_fans }}</span>
          </div>
        </div>

        <!--珍珠-->
        <div class="zhenzhu relativeItem">
          获得珍珠数(个)：{{ n.acquire_pearl }}
          <img
            src="../../assets/live/zhibo.png"
            class="absoluteItem"
            :class="{showimg:show}"
            v-show="n.list.length > 0"
            @click="show = !show"
          />
        </div>

        <!--明细列表 :class="{unshow:!show}" -->
        <transition name="fade">
          <ul class="zhenzhulist" v-show="show">
            <li class="flex-box" v-for="(x, zx) in n.list" :key="zx">
              <div class="flex-box">
                <img class="noevents-img" :src="x.img"/>
                <span class="apostrophe">{{ x.nickname }}</span>
              </div>
              <div>{{ x.pearl }}</div>
            </li>
          </ul>
        </transition>
      </li>
    </ul>

    <!--空表组件-->
    <blank message="今日暂无直播数据" v-if="showBlank" class="blank" />
  </div>
</template>














<script>
import blank from "../me/blank";

export default {
  name: "jinrishuju",
  components: {
    blank
  },
  data() {
    return {
      showBlank: false,
      show: true,
      list:[],
    };
  },
  methods: {
    //获取列表
    getList() {
      let _this = this;
      this.$jsonp(this.$apis("zhiboshuju"), {}, res => {
        if(res.data.data.length>0){
          _this.showBlank = false;
          _this.list = res.data.data;
        }else{
          _this.showBlank = true;
        }
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>















<style scoped>
.jinrilist {
  padding: 0 16px;
  padding-bottom: 16px;
}
.jinrilist > li {
  margin-top: 16px;
  border-radius: 8px;
  overflow: hidden;
  transition: all 1s;
}
.lan {
  padding: 20px 16px;
  background: linear-gradient(to right, #855bfb, #20bbfe);
}
.lan p {
  justify-content: space-between;
  color: white;
  font-size: 15px;
  align-items: center;
  margin-bottom: 21px;
}
.lan p:last-child {
  margin-bottom: 0;
}

/**数量 */
.number {
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 0 16px;
  padding-top: 20px;
  background: #fafafa;
}
.number span {
  font-size: 27px;
  display: block;
  color: #333;
  margin-bottom: 7px;
  margin-top: 2px;
}

/**珍珠 */
.zhenzhu {
  padding: 15px 16px;
  font-size: 17px;
  background: #fafafa;
}
.zhenzhu img {
  right: 16px;
  width: 18px;
  top: 50%;
  transition: all 0.3s;
  transform-origin: center center;
  transform: translateY(-50%) rotateZ(-90deg);
}
.zhenzhu .showimg {
  transform: translateY(-50%) rotateZ(0);
}

/**珍珠list */
.zhenzhulist {
  align-items: center;
  font-size: 15px;
  color: #999;
  background: #fafafa;
  transition: all 1s;
}
.zhenzhulist li {
  justify-content: space-between;
  align-items: center;
  padding: 13px 16px;
}
.zhenzhulist div {
  align-items: center;
}
.zhenzhulist span {
  max-width: 100px;
}
.zhenzhulist img {
  border-radius: 50%;
  margin-right: 12px;
  width: 33px;
  height: 33px;
}
.unshow {
  height: 0px;
}

.blank {
  margin-top: 50%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

